import { persist } from '@/utils/Persist';

export const getShareLinkToken = () => {
  return persist.get('shareLinkToken');
};
